import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Spin,
  Select,
  Statistic,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import SortableColumn from "../../../components/SorterTableColumn";

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: "ID",
    dataIndex: "id",
  },
  {
    title: "Branch",
    dataIndex: "branch",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },

  SortableColumn({
    label: "Transaction Date",
    dataIndex: "transactionDate",
    // sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
    sorter: true,
  }),

  // {
  //   title: "Transaction Date",
  //   dataIndex: "transactionDate",
  //   sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
  // },
  {
    title: "Transaction Tag",
    dataIndex: "transactionTag",
  },

  {
    title: "Account",
    dataIndex: "account",
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
];

const GLA0200 = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    // console.log(searchKey);

    if (!searchKey) {
      setJournalEntryList(originalList);
      return;
    }
    // console.log(originalList);
    const filterBySearch = originalList.filter((item) =>
      item?.transactionDate?.includes(searchKey)
    );
    // console.log(filterBySearch);
    setJournalEntryList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  //END METHODS DECLARED

  useEffect(() => {
    getJournalEntriesAction("DESC");
    // //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
      //   type: cnt.RIGHT_SEARCH_BTN,
    });
    BOM.HasPermission("CREATE_JOURNALENTRY") && rightAction(cnt.RIGHT_ADD_BTN);
    BOM.HasPermission("READ_JOURNALENTRY") && rightAction(cnt.RIGHT_SEARCH_BTN);
  }, []);

  const getJournalEntriesAction = (
    sortOrder = "ASC",
    orderBy = "transactionDate"
  ) => {
    const currentYear = new Date().getFullYear();
    const fromDate = `1 January ${currentYear}`;
    const toDate = `31 December ${currentYear}`;

    let body = { session };

    const apiUrl = `journalentries?dateFormat=dd+MMMM+yyyy&locale=en&offset=0&limit=200&orderBy=${orderBy}&sortOrder=${sortOrder}`;

    BOM.FetchReqAction(body, BOM.baseUrl(apiUrl), (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.pageItems || [];
        let tempArray = objList.map((element) => ({
          key: element?.id,
          id: element?.id || "-",
          branch: element?.officeName || "-",
          transactionDate: element?.transactionDate
            ? `${element?.transactionDate[2]} ${
                monthList[element?.transactionDate[1] - 1]
              } ${element?.transactionDate[0]}`
            : "-",
          transactionId: element?.transactionId || "-",
          type: element?.glAccountType?.value || "-",
          createdBy: element?.createdByUserName || "-",
          account: element?.glAccountName
            ? `${element?.glAccountName} (${element?.glAccountCode})`
            : "-",
          debit:
            element?.entryType?.value?.toLowerCase() === "debit"
              ? element?.amount
              : "-",
          credit:
            element?.entryType?.value?.toLowerCase() === "credit"
              ? element?.amount
              : "-",
          transactionTag: element?.entryType?.value
            ? element?.entryType?.value === "DEBIT"
              ? "Dr"
              : element?.entryType?.value === "CREDIT"
              ? "Cr"
              : "-"
            : "-",
          amount: element?.amount ? (
            <Statistic
              value={element?.amount}
              precision={2}
              valueStyle={{ fontSize: "16px" }}
            />
          ) : (
            "-"
          ),
          amountToUse: element?.amount || 0,
        }));

        setJournalEntryList(tempArray);
        setOriginalList(tempArray);
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
        sortOrder: "DESC",
        orderBy: "transactionDate",
      };

      let body = {
        session,
        params,
      };

      const apiUrl = `journalentries?dateFormat=dd+MMMM+yyyy&locale=en`;

      BOM.FetchReqAction(body, BOM.baseUrl(apiUrl), (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id ? element?.id : "-",
              branch: element?.officeName ? element?.officeName : "-",
              transactionDate: element?.transactionDate
                ? `${element?.transactionDate[2]} ${
                    monthList[element?.transactionDate[1] - 1]
                  } ${element?.transactionDate[0]}`
                : "-",
              transactionId: element?.transactionId
                ? element?.transactionId
                : "-",
              type: element?.glAccountType?.value
                ? element?.glAccountType?.value
                : "-",
              createdBy: element?.createdByUserName
                ? element?.createdByUserName
                : "-",
              account: element?.glAccountName
                ? `${element?.glAccountName} (${element?.glAccountCode})`
                : "-",
              debit:
                element?.entryType?.value?.toLowerCase() === "debit"
                  ? element?.amount
                  : "-",
              credit:
                element?.entryType?.value?.toLowerCase() === "credit"
                  ? element?.amount
                  : "-",
              transactionTag: element?.entryType?.value
                ? element?.entryType?.value === "DEBIT"
                  ? "Dr"
                  : element?.entryType?.value === "CREDIT"
                  ? "Cr"
                  : "-"
                : "-",
              amount: element?.amount?.toLocaleString() || "-",
              amountToUse: element?.amount?.toLocaleString() || "-",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    // console.log(selectedRow);return
    delete selectedRow.amount;
    selectedRow.amount = selectedRow.amountToUse;
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla0200", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-gla0200", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter && sorter.field) {
      const sortOrder = sorter.order === "ascend" ? "ASC" : "DESC";
      const orderBy = sorter.field; // field name from columns (e.g., transactionDate)

      getJournalEntriesAction(sortOrder, orderBy);
    }
  };

  function handleOnSearch() {
    const { searchBtn } = rightBtn;
    if (searchBtn.toLowerCase() === "primary") {
      navigate("/search-gla0200", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onSearch={handleOnSearch}
    >
      <TopContent
        pageTitle={appLabel.journalEntries}
        pageItems={appStatic.journalEntryItems}
      />

      <Card
        title={`${appLabel.journalEntries} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Transaction Date..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={journalEntryList}
              columns={columns}
              fileName={"Journal Entry List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={journalEntryList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
            scroll={{ x: 800 }}
            onChange={handleTableChange}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(GLA0200);
